import React from 'react';
import Oidc from 'oidc-client';

//Identityserver needs this page to call back to in order to complete its sign in process
class SigninSilentCallback extends React.Component {
  constructor(props) {
    super(props);
    new Oidc.UserManager().signinSilentCallback().catch((error) => {
      console.error(error);
    });
  }

  render() {
    return null;
  }
}

export default SigninSilentCallback;
